import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { applyGeoLanguageDefault } from "./geoLang";
import { isArabicPreview } from "./previewLang";

import en from "./locales/en.json";
import ar from "./locales/ar.json";
import de from "./locales/de.json";
import tr from "./locales/tr.json";

const arabicPreview = isArabicPreview();

export const LANGUAGES = [
  { code: "en", label: "English", dir: "ltr" },
  { code: "de", label: "Deutsch", dir: "ltr" },
  { code: "tr", label: "Türkçe", dir: "ltr" },
];

export const dirFor = (code) =>
  code?.split("-")[0] === "ar" ? "rtl" :
    (LANGUAGES.find((l) => l.code === code) || LANGUAGES[0]).dir;

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      de: { translation: de },
      tr: { translation: tr },
      ...(arabicPreview ? { ar: { translation: ar } } : {}),
    },
    lng: arabicPreview ? "ar" : undefined,
    fallbackLng: "en",
    supportedLngs: [...LANGUAGES.map((lng) => lng.code), ...(arabicPreview ? ["ar"] : [])],
    detection: {
      // No "navigator" step here on purpose: a first-time visitor's language
      // is decided by IP-based geolocation (see geoLang.js), defaulting to
      // English when the country can't be determined — not by browser locale.
      order: ["localStorage"],
      lookupLocalStorage: "hayat-lang",
      caches: ["localStorage"],
      // The review language must not replace the regular saved preference.
      excludeCacheFor: ["cimode", "ar"],
    },
    interpolation: { escapeValue: false },
    returnObjects: true,
  });

const applyDir = (lng) => {
  const dir = dirFor(lng);
  document.documentElement.setAttribute("dir", dir);
  document.documentElement.setAttribute("lang", lng);
};

applyDir(i18n.language || "en");
i18n.on("languageChanged", applyDir);

if (!arabicPreview) applyGeoLanguageDefault(i18n);

export default i18n;
